module.exports = __webpack_public_path__ + "static/img/tc02.d094f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/tc02.png
// module id = 171
// module chunks = 0